export default __webpack_public_path__ + "static/media/fellowships.7bf2f902.svg";